import {type DataTestAttrs, getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import React from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementKeyboardEvent, ElementMouseEvent} from 'util/Types';

export interface HelpIconProps {
  className?: string;
  dataTestAttrs?: DataTestAttrs;
  onClick?: (e: ElementMouseEvent | ElementKeyboardEvent) => void;
  onMouseEnter?: (e: ElementMouseEvent) => void;
  onMouseLeave?: (e: ElementMouseEvent) => void;
  onMouseMove?: (e: ElementMouseEvent) => void;
  onPointerDown?: (e: ElementMouseEvent) => void;
  onPointerEnter?: (e: ElementMouseEvent) => void;
  onFocus?: React.FocusEventHandler<HTMLSpanElement>;
  onBlur?: React.FocusEventHandler<HTMLSpanElement>;
  'aria-describedby'?: string;
}

const HelpIcon = React.forwardRef<HTMLSpanElement, HelpIconProps>(
  ({className, dataTestAttrs, onClick, ...props}: HelpIconProps, ref): JSX.Element => (
    <span
      {...getTestProps(dataTestAttrs)}
      aria-label="Help"
      className={classNames('helpIcon-container', className)}
      {...getActionButtonRoleProps({
        onPress: (e) => {
          onClick?.(e);
        },
      })}
      ref={ref}
      {...props}
    >
      <BenchlingIcon className="helpIcon" icon="question" />
    </span>
  )
);

export default HelpIcon;
